export const normalizeInfinityCode = (value) => {
  if (value === undefined || value === null) return null;
  const normalized = String(value).trim();
  if (!normalized || normalized === 'null' || normalized === 'undefined' || normalized === 'NaN') {
    return null;
  }
  return normalized;
};

export const mapEmployeeRecord = (emp) => ({
  employeeId: emp?.infinityCode || emp?.id,
  clientCode: emp?.clientCode ?? null,
  name: emp?.name || emp?.sr || emp?.fullName || emp?.englishName || '',
  arabicName: emp?.arabicName || emp?.name_ar || emp?.sr || emp?.name || '',
  workingCompany: emp?.workingCompany || emp?.contractCompany || null,
  employeeType: emp?.department?.name ?? emp?.employeeType ?? emp?.department ?? null,
});

export const mapEmployeeList = (list) => (Array.isArray(list) ? list.map(mapEmployeeRecord) : []);